import { useRef, useState } from "react"

import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@coval/ui"
import { SlidersHorizontal } from "lucide-react"

interface AudioVisibilityMenuProps {
  waveformAvailable: boolean
  waveformVisible: boolean
  onWaveformVisibleChange: (visible: boolean) => void
  framesVisible: boolean
  onFramesVisibleChange: (visible: boolean) => void
  panelId: string
}

export function AudioVisibilityMenu({
  waveformAvailable,
  waveformVisible,
  onWaveformVisibleChange,
  framesVisible,
  onFramesVisibleChange,
  panelId,
}: AudioVisibilityMenuProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const tooltipDismissed = useRef(false)

  return (
    <DropdownMenu
      open={menuOpen}
      onOpenChange={(open) => {
        if (open) {
          // Menu focus restoration must not reopen the tooltip after selection.
          tooltipDismissed.current = true
          setTooltipOpen(false)
        }
        setMenuOpen(open)
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          icon
          tooltip="Display Options"
          tooltipProps={{
            open: tooltipOpen && !menuOpen,
            className: "data-[state=closed]:hidden",
            onOpenChange: (open) => {
              setTooltipOpen(open && !tooltipDismissed.current)
            },
          }}
          onPointerEnter={() => {
            if (!menuOpen) {
              tooltipDismissed.current = false
            }
          }}
          onBlur={() => {
            if (!menuOpen) {
              tooltipDismissed.current = false
            }
          }}
        >
          <SlidersHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuCheckboxItem
          checked={waveformAvailable && waveformVisible}
          disabled={!waveformAvailable}
          onCheckedChange={onWaveformVisibleChange}
        >
          Audio Waveform
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={framesVisible}
          onCheckedChange={onFramesVisibleChange}
          aria-controls={panelId}
        >
          Data Frames
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
